import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-black text-white py-8">
      <div className="container mx-auto px-6 flex justify-between items-center">
        <p>&copy; 2024 behalf.me. All rights reserved.</p>
        <nav className="flex space-x-4">
          <Link to="/terms" className="hover:text-yellow-400">Terms</Link>
          <Link to="/privacy" className="hover:text-yellow-400">Privacy</Link>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;